import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Header from './Header';
import SideNav from './SideNav';

function Layout() {
    const location = useLocation();

    if ((location.pathname === '/register') || (location.pathname === '/login')) {
        return <div className='App'>
            <Outlet />
        </div>
    }

    return <div className='App'>
        <Header />
        <main>
            <SideNav />
            <Outlet />
        </main>
    </div>;
}

export default Layout;